/// <reference path="../../app.ts" />
namespace Cfnc {

    interface IsearchByZip extends ng.IDirective {

    }

    interface IsearchByZipScope extends ng.IScope {
        filterGroup: IAvaliableFiltersGroup;
        filter: IAvailableFilterOption;
        ngModel: IAvaliableFiltersGroup[];
        selected: boolean;
        range: string;
        zipCode: string;

        updateRange: (string) => void;

        vm: any;
    }

    class searchByZip implements IsearchByZip {
        static directiveId: string = "searchByZip";
        static $inject: Array<string> = ["$window"];
        templateUrl = "/app/directives/campusSearchFilter/searchByZip.html";
        replace: boolean = true;
        restrict: string = "E";
        range: string = "50";
        zipCode: string;
        $q: ng.IQService;

        scope: any =
        {
            ngModel: "=",
            filterGroup: "=",
            filter: "=",
            action: "&"
        };

        constructor(private $window: ng.IWindowService) {
        }

        link = (scope: IsearchByZipScope, element, attrs, $q) => {
            scope.range = "50";

            scope.vm = {
                filterGroup: scope.filterGroup,
                filter: scope.filter,
                range: scope.range,
                zipCode: scope.zipCode
            }

            scope.$watch("ngModel",(newValue: Array<any>) => {
                var index = _.findIndex(newValue,(x: any) => { return x.key == scope.vm.filterGroup.key; });
                if (index > -1) {
                    var values = _.get(_.find(newValue[index].filters, {
                        key: scope.vm.filter.key
                    }), "value", "");
                    var splitValue = values.split(",");
                    scope.range = splitValue[0];
                    scope.zipCode = splitValue[1];
                } else {
                    scope.range = "50";
                    scope.zipCode = "";
                }
            });

            scope.$watch("filter",(newValue) => {
                scope.vm.filter = newValue;
            });

            scope.$watch("zipCode",(zipCode) => {
                this.buildFilter(scope);
            });

            scope.$watch("range",(range) => {
                this.buildFilter(scope);
            });

            scope.updateRange = (distance: string) => {
                scope.range = distance;
            }
        };

        private buildFilter(scope: IsearchByZipScope) {
            if (scope.zipCode && scope.zipCode.length === 5) {

                scope.filter.value = scope.range + "," + scope.zipCode;
                var groups = scope.ngModel.length > 0 ? _.filter(scope.ngModel, { key: scope.filterGroup.key }) : null;
                if (!groups || groups.length < 1) {

                    var newGroup: IAvaliableFiltersGroup = {
                        key: scope.filterGroup.key,
                        category: scope.filterGroup.category,
                        filters: []
                    }

                    newGroup.filters.push(scope.filter);
                    scope.ngModel.push(newGroup);
                } else {
                    var group = groups[0];
                    var existingFilters = _.filter(group.filters, { key: scope.filter.key });
                    if (!existingFilters || existingFilters.length < 1) {
                        group.filters.push(scope.filter);
                    } else {
                        existingFilters[0].value = scope.filter.value;
                    }
                }
            } else {
                if (groups && groups.length > 0) {
                    var group = groups[0];

                    _.remove(group.filters, { key: scope.filter.key });

                    if (group.filters.length < 1) {
                        _.remove(scope.ngModel, { key: group.key });
                    }
                }
            }
        }

        //private buildFilterValue(zipCode, range): string {
        //    var latLong: any = {};
        //    var filterValue: string;

        //    this.getGeoCodeForZip(zipCode);

        //    filterValue = range + "," + latLong.latitude + "," + latLong.longitude;

        //    return filterValue;
        //}

        //private getGeoCodeForZip(zipCode: string) {
        //    var promise = this.getGeoCodeForZipAsync(zipCode);
        //    promise.then(function (latLong: any) {
        //        return latLong;
        //    }, function (reason) {
        //            return "GetGeoCode Status is " + reason;
        //    });
        //}

        //private getGeoCodeForZipAsync(zipCode: string) {
            
        //    var d = this.$q.defer();
        //    var geocoder = new google.maps.Geocoder();
        //    var latlong: any = {};
        //    var result = geocoder.geocode({ address: zipCode },(results, status): any => {
        //        if (status == google.maps.GeocoderStatus.OK) {
        //            latlong.latitude = results[0].geometry.location.lat();
        //            latlong.longitude = results[0].geometry.location.lng();
        //            d.resolve(latlong);
        //        }
        //        else {
        //            d.reject(status);
        //        }
        //    });

        //    return d.promise;

        //}
    }

    // Update the app1 variable name to be that of your module variable
    angular.module("app").directive(searchByZip.directiveId, ['$window', $window =>
        new searchByZip($window)
    ]);
}
